/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {IReceptionCreate, ReceptionData, StepProps} from '../IAppModels'
import {ID} from '../../../../../../../_metronic/helpers'
import {id} from 'date-fns/locale'

const Step2 = ({data, updateData, errorMessage}: StepProps) => {
  const [proposalFilter, setProposalFilter] = useState<string>('')
  const [idCaixa, setIdCaixa] = useState<string>('')

  const updateIdDocSelectedProposals = (proposal: string, value: string) => {
    if (!idCaixa) {
      alert('É necessário informar o ID da Caixa')
      return
    }

    const getProlId = data.proposals.find((p) => p.numeroProposta === proposal)

    if (getProlId) {
      const proposalAlreadyExists = data.selectedProposals.some(
        (sp) => sp.Proposta === getProlId.id
      )

      if (!proposalAlreadyExists) {
        updateData({
          ...data,
          selectedProposals: [
            ...data.selectedProposals,
            {Proposta: getProlId.id, id_documento: value, id_caixa: idCaixa},
          ],
        })
        return
      }

      const updatedSelectedProposals = data.selectedProposals.map((sp) => {
        if (sp.Proposta === getProlId.id) {
          return {...sp, id_documento: value, id_caixa: idCaixa}
        }
        return sp
      })

      updateData({...data, selectedProposals: updatedSelectedProposals})
    }

    return
  }

  useEffect(() => {
    console.log(data)
  }, [data])

  const updateSelectedProposals = (proposal: string, isChecked: Boolean) => {
    const getProlId = data.proposals.find((p) => p.numeroProposta === proposal)

    if (!isChecked) {
      const updatedProposals = data.selectedProposals.filter((p) => p.Proposta !== getProlId?.id)
      updateData({...data, selectedProposals: updatedProposals})
      return
    }

    const updatedProposals: ReceptionData[] = [
      ...data.selectedProposals,
      {Proposta: getProlId?.id, id_documento: '', id_caixa: ''},
    ]

    updateData({...data, selectedProposals: updatedProposals})

    return
  }

  return (
    <div className='pb-5' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*begin::Form Group */}
        <div className='fv-row'>
          {/* begin::Label */}
          <div className='fv-row mb-10'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Para seguir com o processo, é necessário informar o ID da Caixa</span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='proposal'
              placeholder='Digite o ID da Caixa'
              autoComplete='off'
              onChange={(e) => setIdCaixa(e.target.value)}
            />
          </div>

          <hr />

          <label className='d-flex align-items-center fs-5 fw-semibold mb-4'>
            <span className='required'>
              Selecione as propostas recebidas no protocolo {data.protocol}
            </span>
          </label>
          {/* end::Label */}

          <div className='fv-row mb-10'>
            {/* <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Filtrar por proposta</span>
            </label> */}
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='proposal'
              placeholder='Digite o número da proposta'
              autoComplete='off'
              onChange={(e) => setProposalFilter(e.target.value)}
            />
          </div>

          {proposalFilter
            ? data.proposals
                ?.filter((p) => p.numeroProposta && p.numeroProposta.indexOf(proposalFilter) > -1)
                .map((proposal) => (
                  <label className='d-flex align-items-center justify-content-between cursor-pointer mb-6'>
                    <span className='d-flex align-items-center me-2'>
                      <span className='symbol symbol-50px me-6'>
                        <span className='symbol-label bg-light-success'>
                          <i className='fab fa-file-o text-warning fs-2x'></i>
                        </span>
                      </span>

                      <span className='d-flex flex-column'>
                        <span className='fw-bolder fs-6 input-proposalnumber'>
                          Número da proposta: {proposal.numeroProposta}
                          <input
                            type='text'
                            name='id_documento'
                            onChange={(e) =>
                              proposal.numeroProposta &&
                              updateIdDocSelectedProposals(proposal.numeroProposta, e.target.value)
                            }
                            placeholder='Digite o ID do documento'
                            autoComplete='off'
                            className='form-control form-control-lg form-control-solid'
                          />
                        </span>
                        <span className='fs-7 text-muted'>
                          Nome do cliente: {proposal.nomeCliente} / CPF:{' '}
                          {proposal.cpfCliente
                            ?.toString()
                            .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}
                        </span>
                      </span>
                    </span>

                    <span className='form-check form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        name={proposal.numeroProposta}
                        value={proposal.numeroProposta}
                        checked={data.selectedProposals.some((p) => proposal.id === p.Proposta)}
                        onChange={(e) => updateSelectedProposals(e.target.value, e.target.checked)}
                      />
                    </span>
                  </label>
                ))
            : data.proposals?.map((proposal) => (
                <div className='d-flex align-items-center justify-content-between cursor-pointer mb-6'>
                  <span className='d-flex align-items-center me-2'>
                    <span className='symbol symbol-50px me-6'>
                      <span className='symbol-label bg-light-success'>
                        <i className='fab fa-file-o text-warning fs-2x'></i>
                      </span>
                    </span>

                    <span className='d-flex flex-column input-proposalnumber'>
                      <span className='fw-bolder fs-6'>
                        Número da proposta: {proposal.numeroProposta}
                        <input
                          type='text'
                          name='id_documento'
                          onChange={(e) =>
                            proposal.numeroProposta &&
                            updateIdDocSelectedProposals(proposal.numeroProposta, e.target.value)
                          }
                          placeholder='Digite o ID do documento'
                          autoComplete='off'
                          className='form-control form-control-lg form-control-solid'
                        />
                      </span>
                      <span className='fs-7 text-muted'>
                        <b>Nome do cliente:</b> {proposal.nomeCliente} / <b>CPF/CNPJ:</b>{' '}
                        {proposal.cpfCliente
                          ?.toString()
                          .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}
                      </span>
                    </span>
                  </span>

                  <span className='form-check form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      name={proposal.numeroProposta}
                      value={proposal.numeroProposta}
                      checked={data.selectedProposals.some((p) => proposal.id === p.Proposta)}
                      onChange={(e) => updateSelectedProposals(e.target.value, e.target.checked)}
                    />
                  </span>
                </div>
              ))}
        </div>
        {/*end::Form Group */}
      </div>
    </div>
  )
}

export {Step2}
